module.exports = __webpack_public_path__ + "img/next.e732a41a.svg";